export default () => jQuery(($) => {
	$('.topics-menu > a').on('click', function (e) {
		if ($(this).parent().hasClass('topics-active')) {
			$(this).parent().toggleClass('topics-active');
		} else {
			$('.topics-menu').removeClass('topics-active');
			$(this).parent().toggleClass('topics-active');
		}

		return false;
	});

	$('.subnav-menu-button').on('click', function(){
	    $(this).closest('.site-subnav').toggleClass('menu-active');
	    return false;
	});
});
